/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, ErrorFlow, BrickContext } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class OpenIndexedDB extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} dbName
     * @param {string} stores
     * @param {function(): void} forwardEvent
     * @param {function(object): void} setDb
     * @param {function(*): void} setErrorFlow
     */
    update($, [dbName, stores], [forwardEvent, setDb, setErrorFlow]) {
        const openRequest = indexedDB.open(dbName, 1);

        openRequest.onupgradeneeded = (event) => {
            const db = event.target.result;
            for (const store of stores.split(',')) {
                db.createObjectStore(store, { keyPath: 'k' });
            }
        };

        openRequest.onsuccess = () => {
            const db = openRequest.result;
            setDb(db);
            forwardEvent();
        };

        openRequest.onerror = () => {
            // prettier-ignore
            getLogger('OpenIndexedDB').error("An error occurred while opening the db", openRequest.error);
            setErrorFlow(ErrorFlow.create(JSON.stringify(openRequest.error), 1));
        };
    }
}

registerBrick('018ae0d4a6af4abf4e64', OpenIndexedDB);
